var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload03 = function SvgUpload03(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0bd74dbd-ccb6-4ab8-9eb4-48a5fda93fc9a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C2024",
    fillRule: "evenodd",
    d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2M.667 8a7.333 7.333 0 1 1 14.666 0A7.333 7.333 0 0 1 .667 8m4.195-.471 2.667-2.667c.26-.26.682-.26.942 0l2.667 2.667a.667.667 0 1 1-.943.942L8.667 6.943v3.724a.667.667 0 1 1-1.334 0V6.943L5.805 8.47a.667.667 0 1 1-.943-.942",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0bd74dbd-ccb6-4ab8-9eb4-48a5fda93fc9a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgUpload03;